import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, inject, Input } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormBuilder } from "@angular/forms";

const INPUT_CONTROL_ACCESSOR = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => TimeIntervalInputComponent),
	multi: true,
};

@Component({
	selector: "ic-time-interval-input",
	styleUrls: ["time-interval-input.component.scss"],
	providers: [INPUT_CONTROL_ACCESSOR],
	templateUrl: "./time-interval-input.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TimeIntervalInputComponent implements ControlValueAccessor {
	private cdRef = inject(ChangeDetectorRef);
	private formBuilder = inject(UntypedFormBuilder);

	@Input() label: string;
	@Input() inputClass = "";
	@Input() required = true;
	@Input() help: string;
	@Input() missing = false;
	@Input() missingText: string;
	disabled = false;
	form = this.formBuilder.group({
		hours: [""],
		minutes: [""],
	});

	private onTouch = () => {}; // eslint-disable-line @typescript-eslint/no-empty-function
	private onModelChange = (_: unknown) => {};

	writeValue(value: number) {
		if (typeof value !== "number") {
			return;
		}

		this.form.patchValue({
			hours: Math.floor(value / 60),
			minutes: value % 60,
		});

		this.cdRef.markForCheck();
	}

	registerOnChange(fn: (v: unknown) => void) {
		this.onModelChange = fn;
	}

	registerOnTouched(fn: () => void) {
		this.onTouch = fn;
	}

	setDisabledState(isDisabled: boolean) {
		this.disabled = isDisabled;
		this.cdRef.markForCheck();
	}

	onChange() {
		if (typeof this.form.value.hours !== "number" && typeof this.form.value.minutes !== "number") {
			this.onModelChange(null);

			return;
		}

		const value = Number(this.form.value.hours) * 60 + Number(this.form.value.minutes);

		this.onModelChange(value);
	}

	onTouched() {
		this.onTouch();
	}
}
